import React from "react";
import {IntlProvider} from "react-intl";
import {connect} from "react-redux";
import lang from "../locale";

const _IntlProvider = ({locale, children}) => {
  return (
    <IntlProvider locale={locale} messages={lang[locale]}>
      {children}
    </IntlProvider>
  );
};

const mapStateToProps = state => ({
  locale: state.locale,
});

export const WrappedIntlProvider = connect(mapStateToProps)(_IntlProvider);
